import React from 'react';
import { Table } from 'react-bootstrap';
import axios from './../../constants/axios';
import { Link } from 'react-router';

class Manufacturer extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         manufacturers: [],
         filtered: []
      };
   }

   componentDidMount() {
      axios.get('manufacturers')
         .then((res) => {
            this.setState({
               manufacturers: res.data,
               filtered: res.data
            });
         });
   }

   filterOnName = (e) => {
      let searchString = e.target.value;
      this.setState({
         nameString: searchString
      });

      let filtered = this.state.manufacturers.filter((c) => {
         return c.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
      });
      this.setState({
         filtered
      });
   };

   render() {
      const { filtered } = this.state;
      return (
         <Table striped bordered condensed hover >
            <thead>
            <tr>
               <th>Name</th>
               <th>Image</th>
               <th>Actions</th>
            </tr>
            <tr>
               <th>
                  <input className="form-control" type="text" value={this.state.nameString} onChange={this.filterOnName}
                         placeholder="Search By Name" />
               </th>
               <th>
                  &nbsp;
               </th>
               <th>
                  &nbsp;
               </th>
            </tr>
            </thead>
            <tbody>

            {filtered.map((manufacturer) => (
               <tr key={manufacturer.id} >
                  <td>{manufacturer.name}</td>
                  <td>{manufacturer.image}</td>
                  <td>
                     <Link to={`/manufacturer/edit/${manufacturer.id}`} >edit</Link>
                  </td>
               </tr>
            ))}
            </tbody>
         </Table>
      );
   }
}

Manufacturer.propTypes = {};

export default Manufacturer;



/** WEBPACK FOOTER **
 ** ./src/components/Manufacturer/ManufacturerHome.js
 **/